<script lang="ts" setup>
  import { useSubscriptionFlowStore } from "@/stores/subscriptionFlow";
  import Checkout from "@/components/modals/subscription_flow/billing_step/Checkout.vue";
  import CardSelect from "@/components/modals/subscription_flow/billing_step/CardSelect.vue";
  import CardForm from "@/components/modals/subscription_flow/billing_step/CardForm.vue";

  const subscriptionFlowStore = useSubscriptionFlowStore();
</script>

<template>
  <v-container class="container">
    <v-btn
      v-if="subscriptionFlowStore.billingStep !== 'checkout'"
      variant="plain"
      prepend-icon="chevron_left"
      class="breadcrumb"
      @click="subscriptionFlowStore.billingStep = 'checkout'"
    >
      Back
    </v-btn>
    <Checkout v-if="subscriptionFlowStore.billingStep === 'checkout'"></Checkout>
    <CardSelect v-else-if="subscriptionFlowStore.billingStep === 'card-select'"></CardSelect>
    <CardForm v-else-if="subscriptionFlowStore.billingStep === 'card-form'"></CardForm>
  </v-container>
</template>

<style scoped lang="scss">
  .container {
    width: 100%;
    max-width: 500px;
    padding: 0;

    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 2rem;
  }

  .breadcrumb {
    padding: 0;
    margin-left: -1rem;
    margin-bottom: -2rem;

    :deep(.v-btn__prepend) {
      margin-inline-end: unset;
    }
  }

  :deep(.title) {
    font-size: getFontSize('title-2');
    font-weight: getFontWeight('bold');
    line-height: 2rem;
  }
</style>
